import { Injectable, computed, inject, signal } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { FuncData } from '@interfaces';
import { FuncService } from '..';
import { appDataEquality } from './app-data-equality';
import { EMPTY_DATA } from './empty-data';
import { processData } from './process-data/process-data';


@Injectable({ providedIn: 'root' })
export class AppService {

	private util = inject(UtilityService);
	private readonly func = inject(FuncService);

	private readonly _data = signal<FuncData>(EMPTY_DATA, { equal: appDataEquality })
	public readonly data = computed(() => processData(this._data(), this.util));

	public readonly staffDataMap = computed(() => this.util.array.toMap(this.data().staff, s => s.staffId));

	public readonly trimestersDataMap = computed(() => this.util.array.toMap(this.data().trimesters, t => t.trimesterId));

	public async loadData(): Promise<void> {
		this._data.set(await this.func.getData());
	}

	public async clearData(): Promise<void> {
		this._data.set(EMPTY_DATA);
	}

	public async update<T>(action: (payload: T) => Promise<FuncData>, payload: T): Promise<void> {
		this._data.set(await action(payload));
	}

	public getStaffNameById(staffId: number | undefined) {
		if (!staffId) return '';
		return this.staffDataMap()[staffId]?.fullName;
	}

	public getTrimesterNameById(trimesterId: number | undefined) {
		if (!trimesterId) return '';
		return this.trimestersDataMap()[trimesterId]?.name || 'N/A';
	}
}